<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="16px" class="mt-40">
    <div fxFlex="50" class="t-right">{{ ('Activation date'|i18n) + ':*' }}</div>
    <div fxFlex="25" app-input-container>
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="4px">
            <input app-input
                   [matDatepicker]="podEffectiveDate"
                   [min]="minDate"
                   [formControl]="dateControl">
            <mat-datepicker-toggle matSuffix [for]="podEffectiveDate"></mat-datepicker-toggle>
            <mat-datepicker #podEffectiveDate></mat-datepicker>
        </div>
        <div *ngIf="dateControl.invalid && dateControl.dirty" app-error>
            {{ 'Invalid date'|i18n }}
        </div>
    </div>
    <div fxFlex="25"></div>
</div>
<div *ngIf="minDate" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="16px" class="mt-20">
    <div fxFlex="50" class="t-right">
        {{ ('Same date of CER activation'|i18n) + ':' }}
    </div>
    <div fxLayout="row" fxLayoutAlign="space-between">
        <mat-slide-toggle app-toggle [formControl]="dateAsCerControl" class="txt-p-16-4 mr-22"></mat-slide-toggle>
    </div>
    <div fxFlex="25"></div>
</div>
<div class="mb-40"></div>
